import React from 'react';
import { Redirect, Link, Route } from 'react-router-dom';

import styles from './sidebar.scss';

import OrganisationSelector from '../organisations/Selector';
import ProfileList from '../profiles/List';
import Logo from '../icons/Logo';
import { Icon } from '../icons';
import SignOutButton from '../containers/SignOutButton';
import LanguageSwitcher from './LanguageSwitcher';


const SideBar = ({ children }) =>
  <div className="sidebar">
    <div className="sidebar-logo-container">
      <div className="sidebar-logo"></div>
    </div>
    <div className="sidebar-utility">
      <SignOutButton className="sign-out-btn" />
      <div className="sidebar-selector">
        <OrganisationSelector path="/profiles" />
      </div>
      <LanguageSwitcher />
    </div>
    <div className="sidebar-content">
      {children}
    </div>
  </div>

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/layout/SideBar.js